import { money, t } from "@/i18n/booking";
import { kmConVehiculo } from "./kmPack";

const GROUP_KEYS = { insurance: "insurance_title", km: "km_title", recogida: "pickup_point", devolucion: "return_point" };

// Catálogo público: los grupos excluyentes (seguro, km, puntos de entrega) se eligen
// con radio; el resto con cantidad.
export default function PublicCatalog({ lang, products, value, onChange, vehicleKm }) {
  const groups = {};
  const singles = [];
  for (const p of products) {
    if (p.exclusive_group) (groups[p.exclusive_group] ||= []).push(p);
    else singles.push(p);
  }
  const price = (p) => `${money(lang, p.price)} ${p.price_type === "per_day" ? t(lang, "per_day") : p.price_type === "per_unit" ? t(lang, "per_unit") : t(lang, "per_rental")}`;
  const chooseInGroup = (group, id) => {
    const next = { ...value };
    for (const p of groups[group]) delete next[p.id];
    if (id) next[id] = 1;
    onChange(next);
  };
  const setQty = (p, qty) => {
    const next = { ...value };
    if (qty > 0) next[p.id] = Math.min(qty, p.max_qty || 1); else delete next[p.id];
    onChange(next);
  };

  return (
    <div className="space-y-5" data-testid="public-catalog">
      {Object.entries(groups).map(([group, items]) => (
        <fieldset key={group}>
          <legend className="font-medium text-[#1A1A1A] mb-2">{GROUP_KEYS[group] ? t(lang, GROUP_KEYS[group]) : group}</legend>
          <div className="space-y-1">
            {items.map((p) => (
              <label key={p.id} className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="radio" name={`g-${group}`} checked={!!value[p.id]} onChange={() => chooseInGroup(group, p.id)} data-testid={`opt-${p.sku}`} />
                <span className="flex-1">{p.name}
                  {kmConVehiculo(p, vehicleKm) && (
                    <span className="block text-xs text-[#8A8A8A]">{kmConVehiculo(p, vehicleKm)} {t(lang, "km_included")}</span>
                  )}
                </span>
                <span className="text-[#5C5C5C]">{Number(p.price) > 0 ? price(p) : t(lang, "included")}</span>
              </label>
            ))}
          </div>
        </fieldset>
      ))}
      {singles.length > 0 && (
        <fieldset>
          <legend className="font-medium text-[#1A1A1A] mb-2">{t(lang, "extras_title")}</legend>
          <div className="space-y-2">
            {singles.map((p) => (
              <div key={p.id} className="flex items-center gap-2 text-sm">
                <span className="flex-1">{p.name}<span className="block text-xs text-[#8A8A8A]">{price(p)}</span></span>
                <input type="number" min={0} max={p.max_qty || 1} value={value[p.id] || 0}
                  onChange={(e) => setQty(p, Number(e.target.value))} className="w-16 rounded border border-[#DCD8D0] px-2 py-1" data-testid={`qty-${p.sku}`} />
              </div>
            ))}
          </div>
        </fieldset>
      )}
    </div>
  );
}
